export default "__VITE_ASSET__gY7gOor0__"